import React from "react";

export type WithdrawalEligibilityStatus =
  | "ELIGIBLE"
  | "NOT_ELIGIBLE"
  | "REQUESTED"
  | "REJECTED"
  | "WITHDRAWN";

export type StatusBadgeConfig = {
  text: string;
  bgColor: string; // Hex color value
  textColor: string; // Hex color value
  icon: React.ReactNode;
};

export const WITHDRAWAL_STATUS_CONFIGS: Record<
  WithdrawalEligibilityStatus,
  StatusBadgeConfig
> = {
  ELIGIBLE: {
    text: "Eligible to withdraw",
    bgColor: "#E8F7E9",
    textColor: "#008205",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_4584_43)">
          <path
            d="M6.41982 1.00541C7.92721 0.664839 9.50529 0.82081 10.9169 1.44975C11.1688 1.56218 11.2819 1.85785 11.1698 2.10991C11.0575 2.36197 10.7618 2.47594 10.5097 2.36381C9.29504 1.82264 7.93757 1.68796 6.64053 1.981C5.3435 2.27409 4.17538 2.97896 3.31143 3.98979C2.44767 5.00055 1.93411 6.2637 1.84658 7.59038C1.7591 8.91725 2.10233 10.2375 2.82607 11.3531C3.54977 12.4684 4.61505 13.3199 5.86221 13.7808C7.10952 14.2416 8.47279 14.2867 9.74795 13.9097C11.023 13.5327 12.1422 12.7538 12.9384 11.689C13.7345 10.6241 14.165 9.33007 14.1659 8.00053V7.38725C14.1659 7.11128 14.39 6.88752 14.6659 6.88725C14.9421 6.88725 15.1659 7.11111 15.1659 7.38725V8.00053C15.165 9.54591 14.6645 11.0499 13.7392 12.2876C12.8138 13.5252 11.513 14.4306 10.0312 14.8687C8.54929 15.3067 6.96502 15.2548 5.51553 14.7193C4.06603 14.1837 2.82828 13.1934 1.98721 11.897C1.14616 10.6006 0.746907 9.06691 0.848536 7.52495C0.95021 5.98301 1.54774 4.51512 2.55166 3.34038C3.55567 2.16569 4.91255 1.34606 6.41982 1.00541ZM14.3124 2.31303C14.5076 2.11781 14.8251 2.11791 15.0204 2.31303C15.2154 2.50818 15.2153 2.82481 15.0204 3.02006L8.35342 9.69291C8.2597 9.78673 8.1325 9.83933 7.9999 9.8394C7.86742 9.8394 7.74013 9.7875 7.64639 9.69389L5.64639 7.69389C5.45112 7.49863 5.45112 7.18114 5.64639 6.98588C5.8416 6.79108 6.15826 6.79099 6.35342 6.98588L7.9999 8.63237L14.3124 2.31303Z"
            fill="#008205"
          />
        </g>
        <defs>
          <clipPath id="clip0_4584_43">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  REQUESTED: {
    text: "Withdrawal requested",
    bgColor: "#EDF2FF",
    textColor: "#006BD6",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M11.334 0.583008C11.5548 0.583196 11.7515 0.680943 11.8887 0.833008H12.666C12.942 0.833008 13.1658 1.05702 13.166 1.33301C13.166 1.60915 12.9422 1.83301 12.666 1.83301H12.084V4.11426C12.0839 4.66659 11.8642 5.19731 11.4736 5.58789L8.88379 8.17578L11.2969 10.5889C11.6404 10.9325 11.8338 11.3989 11.834 11.8848V14.167H12.666C12.9422 14.167 13.166 14.3908 13.166 14.667C13.1658 14.943 12.942 15.167 12.666 15.167H3.33301C3.05712 15.1668 2.83318 14.9429 2.83301 14.667C2.83301 14.391 3.05702 14.1672 3.33301 14.167H4.16699V11.8848C4.16722 11.3987 4.36037 10.9325 4.7041 10.5889L7.11621 8.17578L4.52832 5.58691C4.13759 5.1963 3.91711 4.66675 3.91699 4.11426V1.83301H3.33301C3.05702 1.83283 2.83301 1.60904 2.83301 1.33301C2.83318 1.05712 3.05712 0.833183 3.33301 0.833008H4.11133C4.2486 0.680742 4.44584 0.583008 4.66699 0.583008C4.88817 0.583102 5.08544 0.680628 5.22266 0.833008H10.7783C10.9156 0.680742 11.1128 0.583008 11.334 0.583008ZM8 8.75C7.98665 8.74999 7.97323 8.74583 7.95996 8.74512L5.41113 11.2959C5.25484 11.4521 5.16704 11.6647 5.16699 11.8857V14.167H10.834V11.8857C10.8339 11.6648 10.746 11.4521 10.5898 11.2959L8.03906 8.74512C8.02601 8.74581 8.01313 8.74999 8 8.75ZM5.41699 1.83301V4.11426L5.42871 4.22852C5.45114 4.34054 5.50593 4.44438 5.58789 4.52637L8 6.93848L10.4131 4.52637L10.4854 4.4375C10.5275 4.37421 10.5573 4.30307 10.5723 4.22852L10.584 4.11426V1.83301H5.41699Z"
          fill="#006BD6"
        />
      </svg>
    ),
  },
  REJECTED: {
    text: "Withdrawal request rejected",
    bgColor: "#FFEFEF",
    textColor: "#CA302B",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M7.91113 0.840818C7.99925 0.824921 8.09091 0.833406 8.17578 0.865232L13.5088 2.86523C13.7037 2.93842 13.8338 3.12478 13.834 3.33301V8C13.8338 10.2228 12.3591 12.0162 10.9961 13.209C10.3042 13.8144 9.61432 14.289 9.09863 14.6113C8.8405 14.7727 8.62423 14.897 8.47168 14.9814C8.39574 15.0235 8.33508 15.056 8.29297 15.0781C8.27213 15.0891 8.25472 15.0976 8.24316 15.1035L8.22559 15.1123L8.22461 15.1133H8.22363C8.11805 15.166 7.99832 15.1797 7.88574 15.1533L7.77637 15.1133L7.75684 15.1035C7.74531 15.0976 7.72886 15.0891 7.70801 15.0781C7.66593 15.056 7.60545 15.0236 7.5293 14.9814C7.37679 14.897 7.16055 14.7727 6.90234 14.6113C6.38665 14.289 5.69694 13.8145 5.00488 13.209C3.64174 12.0162 2.16714 10.2231 2.16699 8V3.33301C2.16713 3.12483 2.29634 2.93846 2.49121 2.86523L7.8252 0.865232L7.91113 0.840818ZM3.16699 3.67871V8C3.16714 9.77664 4.35971 11.3166 5.66309 12.457C6.30401 13.0178 6.94749 13.4601 7.43164 13.7627C7.6655 13.9088 7.86159 14.0217 8 14.0986C8.13843 14.0217 8.3344 13.9089 8.56836 13.7627C9.05257 13.46 9.69686 13.0179 10.3379 12.457C11.6411 11.3166 12.8338 9.77648 12.834 8V3.67871L8 1.86621L3.16699 3.67871ZM9.3125 5.64648C9.50765 5.45133 9.82424 5.45155 10.0195 5.64648C10.2148 5.84174 10.2148 6.15825 10.0195 6.35351L8.70605 7.66601L10.0195 8.97949C10.2148 9.17475 10.2148 9.49126 10.0195 9.68652C9.82426 9.88162 9.50771 9.88173 9.3125 9.68652L7.99902 8.37304L6.68652 9.68652C6.49125 9.88162 6.1747 9.88173 5.97949 9.68652C5.78461 9.49129 5.7845 9.17466 5.97949 8.97949L7.29199 7.66601L5.97949 6.35351C5.78445 6.15829 5.78445 5.8417 5.97949 5.64648C6.1747 5.45127 6.49125 5.45138 6.68652 5.64648L7.99902 6.95898L9.3125 5.64648Z"
          fill="#DF413C"
        />
      </svg>
    ),
  },
  NOT_ELIGIBLE: {
    text: "Not eligible to withdraw",
    bgColor: "#FFF0E9",
    textColor: "#B35000",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M7.91113 0.840818C7.99925 0.824921 8.09091 0.833406 8.17578 0.865232L13.5088 2.86523C13.7037 2.93842 13.8338 3.12478 13.834 3.33301V8C13.8338 10.2228 12.3591 12.0162 10.9961 13.209C10.3042 13.8144 9.61432 14.289 9.09863 14.6113C8.8405 14.7727 8.62423 14.897 8.47168 14.9814C8.39574 15.0235 8.33508 15.056 8.29297 15.0781C8.27213 15.0891 8.25472 15.0976 8.24316 15.1035L8.22559 15.1123L8.22461 15.1133H8.22363C8.11805 15.166 7.99832 15.1797 7.88574 15.1533L7.77637 15.1133L7.75684 15.1035C7.74531 15.0976 7.72886 15.0891 7.70801 15.0781C7.66593 15.056 7.60545 15.0236 7.5293 14.9814C7.37679 14.897 7.16055 14.7727 6.90234 14.6113C6.38665 14.289 5.69694 13.8145 5.00488 13.209C3.64174 12.0162 2.16714 10.2231 2.16699 8V3.33301C2.16713 3.12483 2.29634 2.93846 2.49121 2.86523L7.8252 0.865232L7.91113 0.840818ZM3.16699 3.67871V8C3.16714 9.77664 4.35971 11.3166 5.66309 12.457C6.30401 13.0178 6.94749 13.4601 7.43164 13.7627C7.6655 13.9088 7.86159 14.0217 8 14.0986C8.13843 14.0217 8.3344 13.9089 8.56836 13.7627C9.05257 13.46 9.69686 13.0179 10.3379 12.457C11.6411 11.3166 12.8338 9.77648 12.834 8V3.67871L8 1.86621L3.16699 3.67871ZM9.3125 5.64648C9.50765 5.45133 9.82424 5.45155 10.0195 5.64648C10.2148 5.84174 10.2148 6.15825 10.0195 6.35351L8.70605 7.66601L10.0195 8.97949C10.2148 9.17475 10.2148 9.49126 10.0195 9.68652C9.82426 9.88162 9.50771 9.88173 9.3125 9.68652L7.99902 8.37304L6.68652 9.68652C6.49125 9.88162 6.1747 9.88173 5.97949 9.68652C5.78461 9.49129 5.7845 9.17466 5.97949 8.97949L7.29199 7.66601L5.97949 6.35351C5.78445 6.15829 5.78445 5.8417 5.97949 5.64648C6.1747 5.45127 6.49125 5.45138 6.68652 5.64648L7.99902 6.95898L9.3125 5.64648Z"
          fill="#B35000"
        />
      </svg>
    ),
  },
  WITHDRAWN: {
    text: "Policy withdrawn",
    bgColor: "#F0F0F0",
    textColor: "#4F4F4F",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_4584_538)">
          <path
            d="M0.979292 0.979504C1.17445 0.78435 1.49103 0.784567 1.68632 0.979504L3.51054 2.80372C3.51409 2.80733 3.51784 2.81074 3.52128 2.81446L15.0193 14.3125C15.2146 14.5078 15.2146 14.8243 15.0193 15.0195C14.8241 15.2148 14.5076 15.2148 14.3123 15.0195L11.7576 12.4649C10.7297 13.525 9.54115 14.4182 8.2332 15.1084C8.09069 15.1836 7.92032 15.1862 7.77617 15.1143V15.1133H7.77421C7.77328 15.1128 7.7718 15.1121 7.77031 15.1113C7.76708 15.1097 7.76229 15.1064 7.75664 15.1035C7.74515 15.0976 7.72852 15.089 7.70781 15.0781C7.66574 15.0561 7.60517 15.0236 7.5291 14.9815C7.37659 14.897 7.16035 14.7727 6.90214 14.6113C6.38657 14.2891 5.69658 13.8153 5.00468 13.21C3.64148 12.0172 2.1668 10.2232 2.16679 8.00001V3.33302C2.16687 3.20762 2.21396 3.09062 2.29374 3.00099L0.979292 1.68653C0.784355 1.49125 0.784138 1.17466 0.979292 0.979504ZM3.16679 8.00001C3.1668 9.77679 4.35943 11.3165 5.66289 12.457C6.30394 13.0179 6.94726 13.4611 7.43144 13.7637C7.66302 13.9084 7.85776 14.0199 7.99589 14.0967C9.12451 13.4718 10.1531 12.6832 11.0496 11.7568L3.16679 3.87403V8.00001ZM7.91191 0.840832C7.99971 0.825185 8.09105 0.833547 8.17558 0.865246L13.5086 2.86525C13.7035 2.93844 13.8336 3.12479 13.8338 3.33302V8.00294C13.8305 8.50414 13.7528 9.00276 13.6043 9.48146C13.5224 9.74501 13.2419 9.89226 12.9783 9.81056C12.7147 9.72864 12.5674 9.44827 12.6492 9.18458C12.7682 8.80099 12.8308 8.40162 12.8338 8.00001V3.67872L7.9998 1.86622L6.06816 2.5879C5.80953 2.68446 5.52127 2.5535 5.4246 2.29493C5.32813 2.03628 5.45991 1.74796 5.71855 1.65138L7.82499 0.864269L7.91191 0.840832Z"
            fill="#7D7D7D"
          />
        </g>
        <defs>
          <clipPath id="clip0_4584_538">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
};

export const getWithdrawalStatusConfig = (
  status: WithdrawalEligibilityStatus | undefined
): StatusBadgeConfig | null => {
  if (!status) return null;
  return WITHDRAWAL_STATUS_CONFIGS[status] || null;
};
